import { useState, useEffect, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Typography,
  Paper,
  Grid,
  Divider,
  TextField,
  Button,
  IconButton,
  MenuItem,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AddIcon from "@mui/icons-material/Add";
import * as services from "../../services/services";
import * as dropdown from "../../services/dropdown_service";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { transformPet } from "../../utils/reModelPet";
import { jwtDecode } from "jwt-decode";
import { Snackbar, Alert } from "@mui/material";
import PetsIcon from "@mui/icons-material/Pets";
import { HeaderContext } from "../../App";
const ServiceVaccinePage = () => {
  const navigate = useNavigate();
  const accessToken = localStorage.getItem("accessToken");
  const decoded = jwtDecode(accessToken);
  const { id } = useParams(); // รับ petId จาก route
  const [pet, setPet] = useState(null);
  const [vaccine_dropdown, setVaccineDropdown] = useState([]);
  const [detail, setDetail] = useState([]); // ข้อมูลหมอคนเดียว
  const [open, setOpen] = useState(false);
  const { setTitle, setShowBack } = useContext(HeaderContext);

  useEffect(() => {
    setTitle("บันทึกการฝังไมโครชิบ");
    setShowBack(true);

    return () => {
      setTitle("Bow HIS.");
      setShowBack(false);
    };
  }, [setTitle, setShowBack]);

  const [microchip, setMicrochip] = useState({
    date: "",
    microchip_number: "",
  });
  const [vet, setVet] = useState({
    name: "",
    license_no: "",
    hospital: "",
    note: "",
  });

  useEffect(() => {
    const fetchPet = async () => {
      try {
        const res = await services.getPetBowById(id);
        setPet(res.data || null);
      } catch (err) {
        console.error(err);
      }
    };

    if (id) fetchPet();
  }, [id]);

  const fetchData = useCallback(async () => {
    try {
      const res = await services.getUserDetail();
      if (res.data.success) {
        setDetail(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);
  useEffect(() => {
    const doctor = detail;
    setVet({
      title: doctor.title,
      doctor_id: doctor.id,
      name: doctor.name,
      lastname: doctor.lastname,
      hospital: doctor?.hospital?.name,
      license_no: doctor?.license_no,
      note: "",
    });
  }, [detail]);
  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      if (!file) return resolve(null);

      // ถ้าเป็น string อยู่แล้ว ให้ return ทันที
      if (typeof file === "string") return resolve(file);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const base64String = reader.result.split(",")[1]; // ตัด prefix ออก
        resolve(base64String);
      };
      reader.onerror = (error) => reject(error);
    });

  const saveMicrochip = async () => {
    try {
      if (!pet) return;
      let detail = `${vet.title ?? ""} ${vet.name}  ${vet.lastname}\n${vet.license_no}\n${vet.hospital}`;
      const payload = {
        id: pet.id,
        microchip_date: microchip.date,
        microchip_number: microchip.microchip_number,
        microchip_number_create: "vet",
        microchip_number_detail: detail,
      };
      const res = await services.putMicrochipRecordsBow(payload);
      if (res.status === 200) {
        const microchip_payload = {
          vetId: decoded.id,
          implantDate: new Date(microchip.date),
          microchipNumber: microchip.microchip_number,
        };

        let petData = transformPet(pet, decoded.hospitalId);
        let payload = {
          pet: petData,
          treatments: [
            {
              serviceType: "microchip",
              serviceDate: new Date(microchip.date),
              handledById: decoded.id,
              hospitalId: decoded.hospitalId,
              note: vet.note,
            },
          ],
          microchips: [microchip_payload],
        };
        const resTreat = await services.createTreatments(payload);
        if (resTreat.data.success) {
          setOpen(true); 
          setTimeout(() => {
            navigate(`/search/pet`);
          }, 3000); 
        }
      }
    } catch (err) {
      console.error(err);
      alert("บันทึกไม่สำเร็จ");
    }
  };
  if (!pet)
    return <Typography sx={{ p: 2 }}>กำลังโหลดข้อมูลสัตว์เลี้ยง...</Typography>;

  return (
    <>
      <Box sx={{ p: 2 }}>
        <Paper sx={{ p: 2, mb: 4 }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={pet.image || "/no-image.png"}
                alt={pet.name}
                style={{ width: "70%", borderRadius: 8 }}
              />
            </Grid>
            <Grid item xs={12} md={8}>
              <Typography variant="h6">ชื่อ: {pet.name}</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography>ชนิด: {pet.type}</Typography>
              <Typography>สายพันธุ์: {pet.breed}</Typography>
              <Typography>
                เพศ:{" "}
                {{ m: "ตัวผู้", f: "ตัวเมีย", b: "ไม่ทราบ" }[pet.gender] || "-"}
              </Typography>
              <Typography>วันเกิด: {pet.birthdate}</Typography>
            </Grid>
          </Grid>
        </Paper>
        <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
          วันที่ฝังไมโครชิพ
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid xs={12} md={6}>
          <TextField
            label="วันที่ฝังไมโครชิพ"
            fullWidth
            type="date"
            InputLabelProps={{ shrink: true }}
            value={microchip.date}
            onChange={(e) =>
              setMicrochip((prev) => ({ ...prev, date: e.target.value }))
            }
          />
        </Grid>
        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2, mt: 5 }}>
          เลขไมโครชิพ
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <TextField
              label="เลขไมโครชิพ"
              fullWidth
              value={microchip.microchip_number}
              onChange={(e) =>
                setMicrochip((prev) => ({
                  ...prev,
                  microchip_number: e.target.value,
                }))
              }
            />
          </Grid>
        </Grid>

        <Typography variant="h6" sx={{ mt: 4, mb: 1 }}>
          สัตวแพทย์
        </Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              label="สัตวแพทย์ผู้ให้บริการ"
              value={`${vet.name} ${vet.lastname}`}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="เลขที่ใบอนุญาต"
              value={vet.license_no}
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="ชื่อสถานพยาบาล"
              value={vet.hospital}
              InputLabelProps={{ shrink: true }}
              fullWidth
              disabled
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="ข้อมูลเพิ่มเติม"
              value={vet.note}
              onChange={(e) =>
                setVet((prev) => ({ ...prev, note: e.target.value }))
              }
              multiline
              minRows={3}
              fullWidth
            />
          </Grid>
        </Grid>

        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Button
            variant="contained"
            sx={{
              width: "100%",
              maxWidth: 400,
              color: "#fff",
              fontWeight: "bold",
              fontSize: 16,
              background: "linear-gradient(90deg, #ef771e 0%, #e04b22 100%)",
              "&:hover": {
                background: "linear-gradient(90deg, #e04b22 0%, #ef771e 100%)", // สลับสีตอน hover
              },
            }}
            onClick={saveMicrochip}
          >
            บันทึกการฝังไมโครชิพ
          </Button>
        </Box>

        <Box sx={{ height: 50 }} />
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={3000} // 3 วินาที
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpen(false)}
          severity="success"
          icon={<PetsIcon style={{ color: "green" }} />}
          sx={{ alignItems: "center", fontSize: 16 }}
        >
          บันทึกข้อมูลสำเร็จ
        </Alert>
      </Snackbar>
    </>
  );
};

export default ServiceVaccinePage;
